import { render, staticRenderFns } from "./TemperatureAutomationWidget.vue?vue&type=template&id=a2b0646e"
import script from "./TemperatureAutomationWidget.vue?vue&type=script&lang=js"
export * from "./TemperatureAutomationWidget.vue?vue&type=script&lang=js"
import style0 from "./TemperatureAutomationWidget.vue?vue&type=style&index=0&id=a2b0646e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports